export
const name: string = "ObjId";

export
const preproc: string = ``;

export
const declaration: string = ``;

export
const varyings: string = `
    varying       vec4 v_object_id;
`;

export
const implementation: string = `
    void main()
    {
    #ifdef CLIPPING_PLANE
        resolveClippingPlane();
    #endif

        gl_FragColor = v_object_id;
    }
`;
